import { apiServiceWithFallback } from './api.service';
import { User } from './usersService';

export interface CreateAccountDto {
  name: string;
  owner: {
    email: string;
    password: string;
    name: string;
  };
}

export interface Account {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  users?: User[];
}

export interface CreateAccountResponse {
  account: Account;
  owner: User;
}

class AccountsService {

  async createAccount(data: CreateAccountDto): Promise<CreateAccountResponse> {
    try {
      const response = await apiServiceWithFallback.createAccount(data);
      return response.data as CreateAccountResponse;
    } catch (error) {
      console.error('Error creating account:', error);
      throw error;
    }
  }

  async getAllAccounts(): Promise<Account[]> {
    try {
      console.log('🔍 getAllAccounts: Iniciando chamada...');
      const response = await apiServiceWithFallback.getAllAccounts();
      console.log('🔍 getAllAccounts: Response recebida:', response);
      
      // Estrutura real: response.data = { success: true, data: [...], count: number }
      // Estrutura mock: response.data = { data: [...], success: true }
      
      let accountsArray: any[] = [];
      
      // Verificar se é estrutura da API real
      if (response.data && typeof response.data === 'object' && 'success' in response.data && 'data' in response.data && response.data.success && Array.isArray(response.data.data)) {
        console.log('✅ getAllAccounts: Estrutura API real detectada, processando', response.data.data.length, 'contas');
        accountsArray = response.data.data;
      }
      // Verificar se é estrutura do mock
      else if (response.data && typeof response.data === 'object' && 'data' in response.data && Array.isArray(response.data.data)) {
        console.log('✅ getAllAccounts: Estrutura mock detectada, processando', response.data.data.length, 'contas');
        accountsArray = response.data.data;
      }
      // Verificar se é array direto (fallback)
      else if (Array.isArray(response.data)) {
        console.log('✅ getAllAccounts: Array direto detectado, processando', response.data.length, 'contas');
        accountsArray = response.data;
      }
      else {
        console.error('❌ getAllAccounts: Estrutura não reconhecida:', response);
        console.error('❌ getAllAccounts: response.data:', response.data);
        return [];
      }
      
      console.log('✅ getAllAccounts: Retornando array com', accountsArray.length, 'contas');
      return accountsArray as Account[];
    } catch (error) {
      console.error('Error fetching accounts:', error);
      throw error;
    }
  }

  async getAccount(id: string): Promise<Account> {
    try {
      const response = await apiServiceWithFallback.getAccount(id);
      
      // Para conta individual, a estrutura pode variar
      let accountData: any = null;
      
      if (response.data && typeof response.data === 'object' && 'success' in response.data && 'data' in response.data && response.data.success) {
        accountData = response.data.data;
      } else if (response.data && typeof response.data === 'object' && 'id' in response.data) {
        accountData = response.data;
      } else {
        throw new Error('Account not found');
      }
      
      return accountData as Account;
    } catch (error) {
      console.error('Error fetching account:', error);
      throw error;
    }
  }

  async getAccountUsers(id: string): Promise<User[]> {
    try {
      const response = await apiServiceWithFallback.getAccountUsers(id);
      
      let usersArray: any[] = [];
      
      // Verificar se é estrutura da API real
      if (response.data && typeof response.data === 'object' && 'success' in response.data && 'data' in response.data && response.data.success && Array.isArray(response.data.data)) {
        console.log('✅ getAccountUsers: Estrutura API real detectada, processando', response.data.data.length, 'usuários');
        usersArray = response.data.data;
      }
      // Verificar se é estrutura do mock
      else if (response.data && typeof response.data === 'object' && 'data' in response.data && Array.isArray(response.data.data)) {
        console.log('✅ getAccountUsers: Estrutura mock detectada, processando', response.data.data.length, 'usuários');
        usersArray = response.data.data;
      }
      // Verificar se é array direto (fallback)
      else if (Array.isArray(response.data)) {
        console.log('✅ getAccountUsers: Array direto detectado, processando', response.data.length, 'usuários');
        usersArray = response.data;
      }
      else {
        console.error('❌ getAccountUsers: Estrutura não reconhecida:', response);
        return [];
      }
      
      return usersArray as User[];
    } catch (error) {
      console.error('Error fetching account users:', error);
      throw error;
    }
  }
}

export const accountsService = new AccountsService(); 